import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import Typewriter from 'typewriter-effect'
import { Link } from 'gatsby'

class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width:767px) {
                height: 350px;
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            background-color: rgba(0,0,0,.5);
            @media (max-width:767px) {
                background-size: 100%;
            }
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            font-family: Poppins;
            line-height: 80px;
            color: #fff;
            font-weight: bold;
            text-transform: uppercase;
            text-align: right;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
            }
            @media (max-width:767px) {
                font-size: 25px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading2 = styled.h2`
            font-size: 60px;
            line-height: 60px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            text-align: right;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 50px;
                line-height: 50px;
            }
        `

        const Type = styled.div`
            font-size: 50px;
            line-height: 50px;
            color: #fff;
            text-transform: uppercase;
            font-weight: 500;
            @media (min-width:768px) {
                margin-left: 6px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 50px;
                line-height: 50px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 30px;
                margin-left: 2px;
            }
            span {
                font-family: Teko;
            }
        `
        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #65ff00;
            margin-bottom: 30px;
            text-align: right;            
            @media (min-width:768px) {
                margin-left: auto;
            }
            @media (max-width:767px) {
                margin-left: auto;
            }
        `

        const BottomContent = styled.div`
            position: absolute;
            width: 100%;
            bottom: -14%;
            z-index: 2;
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -35%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `
        const ServiceHeadinga = styled(Link)`
            font-family: Oswald;
            color: #fff;
            transition: .5s;
            &:hover {
              color: #c1eb18;
              text-decoration: none;
            }
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
        `

        const { data } = this.props;
        const imageData = getImage(data.background.childImageSharp.gatsbyImageData);
        
        return (
            <Section>
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <GatsbyImage
                        image={imageData}
                        alt="VASCO Solutions, Empresa de Hosting en Colombia"
                        style={{ position: 'absolute', width: '110%', height: '100%', opacity: 0.6 }}
                    />
                    <Container>
                        <Content>
                            <Heading1>
                                VASCO Solutions
                            </Heading1>
                            <Heading2>
                                Empresa de Software DevSecOps
                            </Heading2>
                            <Separator />
                            <Heading2>
                                <Type>
                                    <Typewriter
                                        options={{
                                            strings: [
                                                'Desarrollo + Seguridad + Operaciones',
                                                'Desarrollo de Apps móviles',
                                                'Desarrollo de Software a la medida',
                                                'Diseño Web',
                                            ],
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </Type>
                            </Heading2>
                        </Content>
                    </Container>
                </Overlay>
                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image} alt="Desarrollo de APPs Android en Bogota" />
                                            <GatsbyImage image={this.props.image1} alt="Desarrollo de APPs iOS en Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            <ServiceHeadinga to="/desarrollo-de-aplicaciones-moviles">Desarrollo de APPs</ServiceHeadinga>
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            En VASCO Solutions, creamos aplicaciones móviles impactantes. Descubre cómo podemos convertir tu visión en realidad. ¡Explora ahora!
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Desarrollo de Software en Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            <ServiceHeadinga to="/desarrollo-de-software">Desarrollo de Software</ServiceHeadinga>
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            VASCO Solutions es una empresa tecnológica de referencia en el desarrollo de soluciones
                                            digitales a la medida, con gran experiencia global.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Diseño web en Pereira" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            <ServiceHeadinga to="/diseno-web">Diseño web en Pereira</ServiceHeadinga>
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            En VASCO Solutions, creamos sitios web que cautivan y convierten. Diseños Web elegantes, versátiles, innovadores y optimizados con SEO.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {
          background: file(relativePath: { eq: "vasco-solutions-colombia.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 2000)
                    }
          }
          image: file(relativePath: { eq: "icons/android-vasco.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image1: file(relativePath: { eq: "icons/apple-vasco.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/sketch.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/web.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
        }
      `}
        render={(data) => {            
            const image = getImage(data.image.childImageSharp.gatsbyImageData);
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            return <Hero data={data} image={image} image1={image1} image2={image2} image3={image3}{...props} />;
        }}
    />
);

export default Iconos;